import React, { useState } from "react";
import { Button, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import MemberMembershipService from "../../../../../../services/member_membership_service";

const ActionEndSuspension = ({ membership, idTenant, user, onRefresh }) => {
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        try {
            setLoading(true);
            await MemberMembershipService.endSuspension(membership.id, idTenant, user, membership);
            toast.success("Plano destrancado e dias estornados com sucesso!");
            if (onRefresh) onRefresh();
        } catch (error) {
            console.error("Erro ao destrancar", error);
            toast.error(error.message || "Erro ao destrancar plano.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-4 border rounded-0 mt-3 bg-white">
            <div className="d-flex align-items-center mb-3">
                <i className="mdi mdi-play-circle-outline fs-4 me-2 text-muted"></i>
                <h6 className="fw-bold mb-0 text-dark text-uppercase" style={{ letterSpacing: "0.5px" }}>
                    Finalizar Trancamento
                </h6>
            </div>
            <p className="text-muted font-size-13 mb-4">
                Isso irá religar o plano e ativar o aluno imediatamente. Os dias agendados que não foram utilizados serão <strong>estornados e devolvidos</strong> para o saldo de suspensões disponíveis, e a data de vencimento será recalculada.
            </p>

            <div className="d-flex justify-content-end">
                <Button color="dark" className="px-4 fw-medium font-size-13 rounded-0" onClick={handleConfirm} disabled={loading} style={{ height: "36px" }}>
                    {loading ? <Spinner size="sm" /> : "Confirmar"}
                </Button>
            </div>
        </div>
    );
};

export default ActionEndSuspension;
